import { WebVTTParser } from "webvtt-parser";

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function extractSpeaker(text: string): string {
  const speakerMatch = text.match(/^([^:]+):/);
  return speakerMatch ? speakerMatch[1] : "Speaker";
}

export function parseVtt(text: string): Array<{ start: number; end: number; text: string; speaker: string }>{
  const parser = new WebVTTParser();
  const result = parser.parse(text, "metadata");
  return result.cues.map((cue: any) => ({
    start: cue.startTime,
    end: cue.endTime,
    text: cue.text,
    speaker: extractSpeaker(cue.text),
  }));
}
